<template>
  <div class="bg-[#231F20] px-4 md:px-12 lg:px-[50px] py-4 md:py-5" :class="{'static-top-bar-isFoodleap': isCNZ}">
    <div class="tw-flex flex-col md:flex-row items-center md:justify-between gap-4 md:gap-6 lg:gap-8 w-full">
      <!-- Logo/Title Section -->
      <div class="flex-shrink-0 w-full md:w-auto text-center md:text-left">
        <div v-if="$store.getters.isEcAerospace">
          <h1 class="text-white text-base md:text-lg lg:text-xl font-museo">{{ title }}</h1>
        </div>
        <div v-else-if="$store.getters.isEcHealth" class="w-[130px] mx-auto md:mx-0">
          <img src="/images/static-home-page/ec-health/canterbury-health-innovation-image.png" :alt="title" class="w-full h-auto"/>
        </div>
      </div>

      <!-- Navigation -->
      <nav class="tw-flex flex-1 justify-center md:justify-start w-full md:w-auto order-3 md:order-2">
        <ul class="tw-flex flex-row md:flex-row items-center justify-center gap-4 md:gap-8 lg:gap-10 w-full md:w-auto flex-wrap">
          <li>
            <router-link
              to="/dashboards/home"
              target="_self"
              class="text-white hover:text-gray-300 transition-colors text-sm md:text-base lg:text-xl cursor-pointer font-dm-sans"
            >
              Home
            </router-link>
          </li>
          <li>
            <router-link
              to="/register"
              target="_self"
              class="text-white hover:text-gray-300 transition-colors text-sm md:text-base lg:text-xl cursor-pointer font-dm-sans"
            >
              Register
            </router-link>
          </li>
          <li>
            <a
              href="mailto:platforms@christchurchnz.com"
              target="_blank"
              class="text-white hover:text-gray-300 transition-colors text-sm md:text-base lg:text-xl cursor-pointer font-dm-sans"
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>

      <!-- Buttons -->
      <div class="tw-flex gap-2 md:gap-3 flex-shrink-0 order-2 md:order-3">
        <ds-button
          class="login_button"
          variant="primary"
          label="Register"
          :style="registerButtonStyle"
          :size="null"
          @click="openSignupModal"
        />
        <ds-button
          class="login_button"
          variant="primary"
          label="Login"
          :style="loginButtonStyle"
          :size="null"
          @click="openSigninModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui.js'
  import MODAL_IDS from '../../constants/modal-ids.js'
  import { trackHeapEvent } from '../../util/analytics.js'
  import NavigationItem from '../Navigation/NavigationItem.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {},
    data () {
      return {}
    },
    methods: {
      openSigninModal () {
        trackHeapEvent('staticHomePage.topBarLogin')

        this.$router.push('/login')
      },
      openSignupModal () {
        trackHeapEvent('staticHomePage.topBarRegister')

        if (this.$store.getters.hasAccessToEcosystemMemberPackages) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.PACKAGES_SIGN_UP)
        } else {
          this.$router.push('/register')
        }
      },
    },
    computed: {
      title () {
        if (this.$store.getters.isEcAerospace) {
          return 'Aerospace Navigator powered by ChristchurchNZ'
        } else if (this.$store.getters.isEcHealth) {
          return 'Canterbury Health Innovation powered by ChristchurchNZ'
        }
      },
      leftLogoUrl () {
        return this.config.logo_url_light || this.config.logo_url
      },
      isCNZ () {
        return this.$store.getters.isCNZEcosystem
      },
      registerButtonStyle () {
        return {
          backgroundColor: '#ED1C24',
          fontWeight: '',
          color: 'white',
          height: 'auto',
          width: '90px',
          border: '2px solid white',
          borderRadius: '4px',
          textTransform: 'capitalize',
        }
      },
      loginButtonStyle () {
        return {
          backgroundColor: '#231F20',
          fontFamily: '',
          fontWeight: '',
          color: 'white',
          height: 'auto',
          width: '90px',
          border: '2px solid white',
          borderRadius: '4px',
          textTransform: 'capitalize',

        }
      },
      config () {
        return this.$store.state.config
      },
    },
    mounted () {
    },
    beforeUnmount () {
    },
    mixins: [],
    components: {
      NavigationItem,
    },
  })
</script>

<style scoped>
  /* Custom button label font family */
  :deep(.button__label) {
    font-family: Museo, serif;
  }

  /* Font utility classes */
  .font-museo {
    font-family: Museo, serif;
  }

  .font-dm-sans {
    font-family: "DM Sans", sans-serif;
  }

  /* Keep minimal custom styles if needed */
  .static-top-bar-isFoodleap {
    /* Add any CNZ-specific styles here if needed */
  }
</style>
